import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import {
  INFINITE_SCROLL,
  ONBOARDING_TEMPLATES_RESOURCE,
  COMMUNITY_TAB_ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../../constants';
import NewOnboardingTemplate from './NewOnboardingTemplate';
import EditOnboardingTemplate from './EditOnboardingTemplate';
import apiRoutes from '../../../../app/api/routes';

const iconTrue = { color: 'green', name: 'check' };
const iconFalse = { name: 'minus', disabled: true, color: 'gray' };

const OnboardingTemplatesOverview = ({ rootUrl }) => {
  const { t } = useTranslation();
  const { id, action, actionId } = useParams();

  return (
    <>
      <HasRight right="onboarding-templates/create">
        <NewOnboardingTemplate
          open={id && action && !actionId}
          communityId={id}
          rootUrl={rootUrl}
        />
      </HasRight>
      <HasRight right="onboarding-templates/update">
        <EditOnboardingTemplate
          open={id && action && actionId}
          communityId={id}
          rootUrl={rootUrl}
        />
      </HasRight>
      <HasRight right="onboarding-templates/create">
        <Link to={`${rootUrl}/${COMMUNITY_TAB_ACTIONS.NEW_RELATION}`}>
          <Button btnprimary icon="plus" content={t('newOnboardingTemplate')} />
        </Link>
      </HasRight>
      <Table
        url={addParametersToUri(apiRoutes.onboardingTemplates(), { communityId: id })}
        infiniteScroll={INFINITE_SCROLL}
        resource={ONBOARDING_TEMPLATES_RESOURCE}
        pageSize={50}
        noUserSettings
        resizable
        filtered
        sorted
      >
        <Actions.Link
          iconbutton
          width="2.5rem"
          icon="eye"
          align="center"
          url={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}/${COMMUNITY_TAB_ACTIONS.EDIT_ONBOARDING_TEMPLATE}/:id`}
        />
        <Params.String grow name="name" width="16rem" minWidth="16rem" />
        <Params.String grow name="tag" width="8rem" noFilter noSort />
        <Params.Bool
          name="isInternal"
          label="isGloballyManaged"
          width="8rem"
          minWidth="8rem"
          iconTrue={iconFalse}
          iconFalse={iconTrue}
          grow
        />
        <Menu width="3.5rem" align="center" hasRight="onboarding-templates/delete">
          <Actions.Delete
            url={apiRoutes.onboardingTemplates(':id')}
            confirmMessage={t('areYouSureRemoveOnboardingTemplate')}
          />
        </Menu>
      </Table>
    </>
  );
};

OnboardingTemplatesOverview.propTypes = { rootUrl: PropTypes.string.isRequired };

export default OnboardingTemplatesOverview;
